import { render, staticRenderFns } from "./moreBar.vue?vue&type=template&id=4edce050"
import script from "./moreBar.vue?vue&type=script&lang=js"
export * from "./moreBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4edce050')) {
      api.createRecord('4edce050', component.options)
    } else {
      api.reload('4edce050', component.options)
    }
    module.hot.accept("./moreBar.vue?vue&type=template&id=4edce050", function () {
      api.rerender('4edce050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/bar/components/moreBar.vue"
export default component.exports